module.exports = __webpack_public_path__ + "static/img/4.a8976d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/zh/4.png
// module id = BRF2
// module chunks = 0